import { examplesOrig } from "./cached_data/examples";
import { examplesNoveltyBench } from "./cached_data/novelty_bench";
import { examplesQalign } from "./cached_data/qalign";

export const examples = examplesOrig;